import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconSizesEnum, IIcon } from '../../icon/icon.component';

@Component({
  selector: 'i2g-dialog-loading',
  templateUrl: './dialog-loading.component.html',
  styleUrls: ['./dialog-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogLoadingComponent {
  static isDismissible = false;

  @Input() label;

  loadingSpinnerIcon: IIcon = {
    name: 'i2g-loading',
    size: IconSizesEnum.x_large,
  };
}
